<template>
	<ion-page>
		<spot-header :title="pageTitle" :canGoHome="true" :showLogo="false" @pressedGoHome="$router.push('/home')"></spot-header>
		<ion-content :fullscreen="true"> <!--v-if="isActive"-->
			<ion-item v-if="!isActive || searchingData">
				<ion-spinner name="lines" color="primary"></ion-spinner>
				<ion-label color="primary">{{ spinnerText}}</ion-label>
			</ion-item>
			<div id="actionArea" v-if="isActive">
				<div id="search" v-if="!showResults">
					<div v-if="currField.id == field.employee">
						<spot-select-custom
							:ref="currField.name"
							:label="currField.text"
							:allignLabel="currField.allignLabel"
							:required="currField.required"
							:placeholder="getPlaceHolder()"
							:enabled="!isOptionDisposable"
							:value="currField.value"
							:options="tablesData.employees"
							:optionField="currField.refField"
							:canAddItem="currField.canAddItem"
							:canRefreshList="currField.canRefresh"
							:canUnlock="currField.canUnlock"
							:custom-label="customEmployee"
							selectedLabel="Selezionato"
							deselectLabel="rimuovi"
							selectLabel="seleziona"
							@selected="detectSelection"
							@unselected="detectUnselection">
						</spot-select-custom>
					</div>
					<ion-item v-for="element in searchOptions" :key="element.id">
						<ion-label class="select-option">{{element.text}}</ion-label>
						<ion-checkbox slot="start" :disabled="!element.enabled" v-model="element.isChecked">
						</ion-checkbox>
					</ion-item>
					<spot-button fill="outline" size="large" color="primary" icon="searchCircle" :enabled="!isEmptyRequiredFields()" :expand="null" :text="buttonSearchText" @clicked="executeSearch()">
					</spot-button>
				</div>
				<div class="results" v-if="showResults"> <!-- v-else -->
					<div class="package-title" v-if="packageCode">{{ labelPackage }} {{ packageCode }}</div>
					<div class="group-title">
						<ion-label v-if="receiptsFound.length > 0">{{ labelReceivingText }} ({{ receiptsFound.length }})</ion-label>
					</div>
					<ion-item v-for="element in receiptsFound" :key="element.id" :color="checkDisposable(element) ? 'medium' : 'light'">
						<ion-label>{{element.code}}</ion-label>
						<ion-icon v-if="element.closed" :icon="bagCheck" color="success"></ion-icon>
						<ion-icon v-if="element.disposed" :icon="trashBin" color="danger"></ion-icon>
						<spot-button fill="solid" size="default" color="primary" icon="logInOutline" :expand="null" :text="buttonOpenText" @clicked="openReceipt(element.id)">
						</spot-button>
					</ion-item>
					<div class="group-title">
						<ion-label v-if="shipmentsFound.length > 0">{{ labelShippingText }} ({{ shipmentsFound.length }})</ion-label>
					</div>
					<ion-item v-for="element in shipmentsFound" :key="element.id" :color="checkDisposable(element) ? 'medium' : 'light'">
						<ion-label>{{element.code}}</ion-label>
						<ion-icon v-if="element.closed" :icon="bagCheck" color="success"></ion-icon>
						<ion-icon v-if="element.disposed" :icon="trashBin" color="danger"></ion-icon>
						<spot-button fill="solid" size="default" color="primary" icon="logOutOutline" :expand="null" :text="buttonOpenText" @clicked="openShipment(element.id)">
						</spot-button>
					</ion-item>
					<spot-button fill="clear" size="large" color="primary" icon="chevronBackCircleOutline" :expand="null" :text="buttonGoBackText" @clicked="goBack()">
					</spot-button>
				</div>
			</div>
			<div id="debugArea" style="color:red;" v-if="settings.global.debug">
				<div>Test Area</div>
				Current Field: {{ currField }}<br>
				<div v-for="element in fields.list" :key="element.id">
					{{ element.name }} = {{ element.value }}
				</div>
			</div>
		</ion-content>
	</ion-page>
</template>

<style src="vue-multiselect/dist/vue-multiselect.css"></style> <!--<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>-->
<style scoped>
	ion-label {
		font-weight:bold;
	}
	.select-option {
		margin-right: .5em;
	}
	.results {
		margin-top: .5em;
	}
	ion-item {
		margin-left: .5em;
		margin-right: .5em;
	}
	.package-title {
		font-weight: bold;
		text-align: center;
	}
	.group-title {
		font-weight: bold;
		margin-left: 3em;
		margin-top: 1em;
	}
</style>

<script>
	import { IonCheckbox, IonContent, IonIcon, IonItem, IonLabel, IonPage, IonSpinner } from "@ionic/vue";
	import { bagCheck, chevronBackCircleOutline, logInOutline, logOutOutline, searchCircle, trashBin } from "ionicons/icons";
	import { defineComponent } from "vue";
	import SpotButton from "../components/SpotButton.vue";
	import SpotHeader from "../components/SpotHeader.vue";
	import SpotSelectCustom from "../components/SpotSelectCustom.vue";
	import { showMsgWarning } from "../plugins/common.js";
	import { settings } from "../plugins/settings.js";
	import { getPastDate, jsonSearchProjectRows, tablesData } from '../plugins/customDatabase.js';

	export default defineComponent({
		name: "SearchElements",
		props: {
			pageTitle: { type: String, default: "Cerca" },
			defaultSpinnerText: { type: String, default: "Caricamento..." },
			loadingSearchedItemsText: { type: String, default: "Caricamento Risultati..." },
			buttonSearchText: { type: String, default: "Ricerca" },
			buttonGoBackText: { type: String, default: "Nuova Ricerca" },
			buttonOpenText: { type: String, default: "Apri" },
			labelReceivingText: { type: String, default: "RICEZIONI" },
			labelShippingText: { type: String, default: "SPEDIZIONI" },
			labelPackage: { type: String, default: "Oggetti in:" },
			messageTitleSearch: { type: String, default: "Ricerca colli" },
			warningSearchMultiple: { type: String, default: "La Ricezione / Spedizione Multipla cercata non è presente nello Stabilimento - Magazzino corrente !!!" },
			warningSearchEmployee: { type: String, default: "Ricezioni / Spedizioni associate al dipendente selezionato non sono presenti nello Stabilimento - Magazzino corrente !!!" },
			warningSearchReceipts: { type: String, default: "Ricezioni Aperte associate al dipendente selezionato non sono presenti nello Stabilimento - Magazzino corrente !!!" },
			warningSearchShipments: { type: String, default: "Spedizioni Aperte associate al dipendente selezionato non sono presenti nello Stabilimento - Magazzino corrente !!!" },
			warningSearchOpened: { type: String, default: "Ricezioni / Spedizioni Aperte associate al dipendente selezionato non sono presenti nello Stabilimento - Magazzino corrente !!!" },
			warningSearchDisposables: { type: String, default: "Ricezioni Smaltibili non sono presenti nello Stabilimento - Magazzino corrente !!!" },
		},
		components: {
			IonPage,
			IonItem,
			IonIcon,
			IonContent,
			IonSpinner,
			IonLabel,
			IonCheckbox,
			SpotHeader,
			SpotSelectCustom,
			SpotButton,
		},
		data: () => ({
			isActive: null,
			showResults: false,
			projectId: null,
			packageCode: null,
			isOptionDisposable: null,
			disposableDate: null,
			spinnerText: null,
			searchingData: null,
			field: {
				employee: 0,
			},
			fields: {
				currentId: 0,
				list: [
					{ id: 0, name: 'employee', text: 'Mittente / Destinatario', allignLabel: false, placeholder: 'Seleziona Dipendente', inputType: "combo", defaultValue: null, value: null, required: false, refField: 'id', canAddItem: false, canSkip: false, canGoBack: false, canGoAhead: true, canSave: false, canRefresh: false, canUnlock: false },
				],
			},
			searchOption: {
				receipts: 0,
				shipments: 1,
				all: 2,
				disposables: 3,
			},
			searchOptions: [
				{ id: 0, name: 'receipts', text: 'Ricezioni Aperte', enabled: true, isChecked: false },
				{ id: 1, name: 'shipments', text: 'Spedizioni Aperte', enabled: true, isChecked: false },
				{ id: 2, name: 'all', text: 'Tutto', enabled: true, isChecked: false },
				{ id: 3, name: 'disposables', text: 'Ricezioni Smaltibili', enabled: false, isChecked: false }
			],
			searchCircle,
			logInOutline,
			logOutOutline,
			bagCheck,
			trashBin,
			chevronBackCircleOutline,
			settings,
			showMsgWarning,
			getPastDate,
			jsonSearchProjectRows,
			tablesData,
		}),
		computed: {
			currField() {
				return this.fields.list[this.fields.currentId]
			},
			receiptsFound() {
				return this.tablesData.projectRows.filter(function (projectRow) {
					return (projectRow.project.receiving == true)
				})
			},
			shipmentsFound() {
				return this.tablesData.projectRows.filter(function (projectRow) {
					return (projectRow.project.shipping == true)
				})
			},
			allOpened() {
				const employee = this.fields.list[this.field.employee].value;
				return {
					q: {
						'plant_id_eq': this.tablesData.currentPlant.id,
						'warehouse_id_eq': this.tablesData.currentWarehouse.id,
						...(employee ? { 'employee_id_eq': employee.id } : { 'employee_id_null': true }),
						'disposed_eq': false,
						'closed_eq': false,
					}
				}
			},
			allReceiptsOpened() {
				const employee = this.fields.list[this.field.employee].value;
				return {
					q: {
						'plant_id_eq': this.tablesData.currentPlant.id,
						'warehouse_id_eq': this.tablesData.currentWarehouse.id,
						...(employee ? { 'employee_id_eq': employee.id } : { 'employee_id_null': true }),
						'project_receiving_eq': true,
						'disposed_eq': false,
						'closed_eq': false,
					}
				}
			},
			allShipmentsOpened() {
				const employee = this.fields.list[this.field.employee].value;
				return {
					q: {
						'plant_id_eq': this.tablesData.currentPlant.id,
						'warehouse_id_eq': this.tablesData.currentWarehouse.id,
						...(employee ? { 'employee_id_eq': employee.id } : { 'employee_id_null': true }),
						'project_shipping_eq': true,
						'disposed_eq': false,
						'closed_eq': false,
					}
				}
			},
			allEmployeeRows() {
				const employee = this.fields.list[this.field.employee].value;
				return {
					q: {
						'plant_id_eq': this.tablesData.currentPlant.id,
						'warehouse_id_eq': this.tablesData.currentWarehouse.id,
						...(employee ? { 'employee_id_eq': employee.id } : { 'employee_id_null': true }),
					}
				}
			},
			allProjectRows() {
				return {
					q: {
						'plant_id_eq': this.tablesData.currentPlant.id,
						'warehouse_id_eq': this.tablesData.currentWarehouse.id,
						'project_id_eq': this.projectId,
					}
				}
			},
			allDisposables() {
				return {
					q: {
						'plant_id_eq': this.tablesData.currentPlant.id,
						'warehouse_id_eq': this.tablesData.currentWarehouse.id,
						'project_receiving_eq': true,
						'created_at_lt': this.disposableDate,
						'disposed_eq': false, //to show only not disposed
						'closed_eq': false, //to show only not closed
					}
				}
			},
		},
		async ionViewWillEnter() {
			this.getUrlParamsAndQuery();
			await this.setDefault();
			await this.getAllTablesData();
			await this.acquireProjectRows();
			this.isActive=true;
		},
		ionViewWillLeave() {
			document.activeElement?.blur();
			this.isActive=false;
		},
		methods: {
			//Settings
			getUrlParamsAndQuery() {
				if (this.$route.params.id) {
					this.projectId	= this.$route.params.id;
					this.packageCode = this.$route.query.code;
				}
				else {
					this.projectId	= null;
					this.packageCode = null;
				}
				this.isOptionDisposable = (/true/i).test(this.$route.query.disposable);
			},
			async setDefault() {
				this.spinnerText = this.defaultSpinnerText;
				this.fields.currentId = 0;
				this.fields.list.forEach(element => element.value = element.defaultValue);
				this.searchOptions.forEach(element => element.isChecked = false);
				this.searchingData = false;
				this.enableSearchOptions();
				this.disposableDate = await getPastDate(this.settings.global.disposeWaitingDays);
			},
			enableSearchOptions() {
				if (this.isOptionDisposable) {
					this.searchOptions.forEach(element => element.enabled = false);
					this.searchOptions[this.searchOption.disposables].isChecked = true;
				}
				else {
					this.searchOptions.forEach(element => element.enabled = true);
					this.searchOptions[this.searchOption.disposables].enabled = false;
					this.searchOptions[this.searchOption.disposables].isChecked = false;
				}
			},
			getPlaceHolder() {
				return (this.settings.global.showFieldsPlaceholder) ? this.currField.placeholder : ''
			},
			isEmptyRequiredFields() {
				let ret = false;
				this.fields.list.forEach(element => {if (element.required && !element.value) ret=true});
				if (ret==false) {
					ret=true;
					this.searchOptions.forEach(element => {if (element.isChecked == true) ret=false});
				}
				return ret;
			},
			customEmployee ({ name, surname, department, seat, seat_code }) {
				let infoDepartment = "";
				if (department)
					infoDepartment = " (" + department.name + ")"
				else if (seat)
					infoDepartment = " (" + seat + ")"
				else if (seat_code)
					infoDepartment = " (" + seat_code + ")"
				return name + " " + surname + infoDepartment
			},
			//Database
			async getAllTablesData() {
				// Do Nothing
			},
			checkDisposable(elementToCheck) {
				return (elementToCheck.closed == false && elementToCheck.disposed == false && elementToCheck.created_at < this.disposableDate);
			},
			async searchRecords(currSearch, msgWarning) {
				this.spinnerText = this.loadingSearchedItemsText;
				this.searchingData = true;
				this.tablesData.projectRows = [];
				await this.jsonSearchProjectRows(currSearch);
				this.searchingData = false;
				if (this.tablesData.projectRows) {
					this.showResults = true;
				}
				if (this.tablesData.projectRows.length < 1) {
					this.showMsgWarning(this.messageTitleSearch,msgWarning);
				}
			},
			//Actions
			detectSelection(value) {
				this.currField.value = value;
			},
			detectUnselection() {
				this.currField.value = this.currField.defaultValue;
			},
			async acquireProjectRows() {
				this.showResults = true;
				if (this.projectId) {
					await this.searchRecords(this.allProjectRows,this.warningSearchMultiple);
				}
				else { 
					if (this.isOptionDisposable) {
						await this.searchRecords(this.allDisposables,this.warningSearchDisposables);
					}
					else{
						this.showResults = false;
					}
				}
			},
			async executeSearch() {
				if (this.searchOptions[this.searchOption.all].isChecked==true) {
					await this.searchRecords(this.allEmployeeRows,this.warningSearchEmployee);
				}
				else {
					if (this.searchOptions[this.searchOption.receipts].isChecked==true && this.searchOptions[this.searchOption.shipments].isChecked==false) await this.searchRecords(this.allReceiptsOpened,this.warningSearchReceipts);
					if (this.searchOptions[this.searchOption.receipts].isChecked==false && this.searchOptions[this.searchOption.shipments].isChecked==true) await this.searchRecords(this.allShipmentsOpened,this.warningSearchShipments);
					if (this.searchOptions[this.searchOption.receipts].isChecked==true && this.searchOptions[this.searchOption.shipments].isChecked==true) await this.searchRecords(this.allOpened,this.warningSearchOpened);
					if (this.searchOptions[this.searchOption.disposables].isChecked==true) await this.searchRecords(this.allDisposables,this.warningSearchDisposables);
				}
			},
			openReceipt(movementId) {
				this.$router.push(`/finalize/receipt/`+ movementId + `?from_search=true`);
			},
			openShipment(movementId) {
				this.$router.push(`/finalize/shipment/`+ movementId + `?from_search=true`);
			},
			addItem(tableName) {
				if (tableName) {
				//TODO: Implementa la funzionalità generica AddItem
				}
			},
			goBack() {
				this.showResults = false;
			},
		},
	});
</script>